export default __webpack_public_path__ + "static/media/640_dummy2016-immobilien01-mobile-de.9a58ea5f.png";